// The sort control a tile presentation brings with it.
//
// In a table the sort control is the column header, so a presentation with no header row loses
// sorting altogether unless it brings its own. This one writes the same URL state the headers
// write - the caller's `onSort` is the same function - which is why a sort survives a rotation
// from tiles to table and why a shared link behaves the same in both.

export default function TileSort({ options, query, onSort }) {
  const ascending = query.direction === 'asc';

  return (
    <div className="tile-sort">
      <label>
        Sort by
        <select value={query.sort} onChange={(e) => onSort(e.target.value)}>
          {options.map((option) => (
            <option key={option.key} value={option.key}>{option.label}</option>
          ))}
        </select>
      </label>
      {/* Re-sorting on the column already sorted is what reverses it, exactly as clicking its
          header does. */}
      <button
        type="button"
        className="icon-button"
        onClick={() => onSort(query.sort)}
        aria-label={ascending ? 'Sort descending' : 'Sort ascending'}
        title={ascending ? 'Sort descending' : 'Sort ascending'}
      >
        <span aria-hidden="true">{ascending ? '↑' : '↓'}</span>
      </button>
    </div>
  );
}
